import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_GROUP_SAGA } from "../sagaTypes";
import { loaderAction, groupFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getGroupsSagaAction } from "../sagaActions";
import { GROUP_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_group`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateGroup(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id || '');
        formData.append('name', args.data.name);
        formData.append('establishments', args.data.establishments);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем список товаров
            yield put(getGroupsSagaAction());
            // Очищаем форму товаров
            yield put(groupFormAction(GROUP_FORM_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateGroup() {
    yield takeLatest(UPDATE_GROUP_SAGA, workerUpdateGroup);
}